import { render, staticRenderFns } from "./addCommonProductModal.vue?vue&type=template&id=1e18f8f4&scoped=true"
import script from "./addCommonProductModal.vue?vue&type=script&lang=js"
export * from "./addCommonProductModal.vue?vue&type=script&lang=js"
import style0 from "./addCommonProductModal.vue?vue&type=style&index=0&id=1e18f8f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e18f8f4",
  null
  
)

export default component.exports